import React from "react";
import { PageHeader } from "antd";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useIsMobileWindowSize } from "Hooks/useWindowResize";
import EmptyState from "Components/EmptyState/EmptyState";
import BackEmptyChat from "./BackEmptyChat";
interface props {
    isMobile: boolean;
    isActiveView: boolean;
    className: string;
    closeChatCb: () => void;
    logoutCb: () => void;
}
function EmptyChat({ isActiveView, className, closeChatCb, logoutCb }: props) {
    const { t } = useTranslation();
    const isMobileSize = useIsMobileWindowSize();
    return (
        <section
            className={`${className.split(",").map((item: string) => item)} agent-chat`}
            style={{ zIndex: isActiveView ? 1 : 0 }}
        >
            <PageHeader
                key="chatHandlerHeader"
                subTitle={t("conversations")}
                onBack={isMobileSize ? () => closeChatCb() : undefined}
                extra={<BackEmptyChat logoutCb={logoutCb} />}
            />
            <EmptyState icon={faComments} text={t("noChatOpen")} />
        </section>
    );
}

export default EmptyChat;
